import {HTMLAttributes} from 'react';
import {UrlLink} from '../../../applink/UrlLink';
import {twMerge} from '../../../common/twMerge';

export interface ScheduleTabItemType {
  name: string;
  param: string;
  href?: string;
}

export interface ScheduleTabProps extends HTMLAttributes<HTMLDivElement> {
  days: ScheduleTabItemType[];
  activeParam: string;
  onDayChange: (param: string) => void;
}

/**
 * 대메뉴 요일연재에서만 사용되는 탭입니다.
 * @harry-hi: 서브탭과 디자인이 거의 비슷하여 7차 이후 서브탭 구현시에 해당 컴포넌트를 재사용할 수 있는지 확인해야합니다.
 */
export function ScheduleTab({
  days,
  activeParam,
  onDayChange,
  className,
  ...props
}: ScheduleTabProps) {
  return (
    <div
      role="tablist"
      className={twMerge(
        'relative flex h-44pxr w-full items-center border-b border-theme-transparent-20 bg-theme-bg-base px-15pxr',
        'justify-between tablet:justify-start tablet:gap-x-40px',
        className
      )}
      {...props}
    >
      {days.map(day => {
        const isActive = day.param === activeParam;
        return (
          <UrlLink
            url={day.href}
            key={day.param}
            onClick={() => onDayChange(day.param)}
            className={twMerge(
              'h-full relative flex cursor-pointer flex-col items-center justify-end pb-8pxr pt-14pxr px-3pxr'
            )}
          >
            <div
              className={twMerge(
                'flex flex-col justify-center text-center',
                isActive
                  ? 'font-medium1-bold text-theme-solid-100'
                  : 'font-medium1 text-theme-solid-60'
              )}
            >
              {day.name}
            </div>
            {isActive && (
              <div className="absolute -bottom-1px left-0 right-0 h-2pxr rounded-100pxr bg-theme-solid-100" />
            )}
          </UrlLink>
        );
      })}
    </div>
  );
}
